export default "/images/vendor/flag-icon-css/flags/1x1/ua.svg?2dd397cb920452449acaff2aa80a167d";